/**
 * @generated SignedSource<<5194e812da72868390d770e27bd77824>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRecentlySoldItems_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer" | "SbSharedThinBrowseItemTrackingProvider_viewer">;
  readonly " $fragmentType": "SbSharedRecentlySoldItems_viewer";
};
export type SbSharedRecentlySoldItems_viewer$key = {
  readonly " $data"?: SbSharedRecentlySoldItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRecentlySoldItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRecentlySoldItems_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedThinBrowseItemTrackingProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "d93eccac4ebfc0ebbb87e921f5678147";

export default node;
